import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import ServiceTable from '../Table/table';
import { makeStyles } from '@material-ui/core';
import { CommonConfig } from '../../../../config/common-config';
import ServiceLayout from '../../../invoices/common/serviceLayout';
// import moment from 'moment';
import Noofcloseservices from '../ClosedService/Noofclosedservices';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

const ClosedService = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setClosedService] = useState([]);
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const typereq = tennantDetails.typeReq && tennantDetails.typeReq;
    const tennantname = tennantDetails.tennantName && tennantDetails.tennantName;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const usertypeValue = userDetails.result && userDetails.result.data.features[5].branchName;
    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };

    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'clientId', label: 'Client ID' },
        { id: 'clientName', label: 'Client name' },
        { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'serviceYear', label: 'Year' },
        { id: 'startDate', label: 'Start date' },
        { id: 'dateModified', label: 'End date' },
        { id: 'comments', label: 'Remarks' },
        { id: 'statusId', label: 'Status', isConcat: 'true', concatElem: ['statusText'] },
    ];

    const headcellsClients = [
        { id: 'serviceId', label: 'Service ID' },
        // { id: 'clientId', label: 'Client ID' },
        // { id: 'clientName', label: 'Client name' },
        // { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'serviceYear', label: 'Year' },
        { id: 'startDate', label: 'Start date' },
        { id: 'dateModified', label: 'End date' },
        { id: 'comments', label: 'Remarks' },
        { id: 'statusId', label: 'Status', isConcat: 'true', concatElem: ['statusText'] },
    ];

    function formatDate(props) {
        return props.map((element) => {
            // const tempStartDate = element.startDate;
            const tempEndDate = element.dateModified;
            // const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            // const formatStartDate = new Date(tempStartDate.replace(pattern, '$3-$2-$1'));
            // const formatEndDate = new Date(tempEndDate.replace(pattern));
            // element.startDate = moment(formatStartDate).format('DD-MM-YYYY');
            // element.dateModified = moment(tempEndDate).format('DD-MM-YYYY')
            element.dateModified = tempEndDate.split(' ', 1);
            // console.log("element.dateModified", element.dateModified);
        });
    }

    // const getCandidates = () => {
    //     setLoading(true);
    //     setpreviousButton(true);
    //     setnextButton(true);
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/closeservice/${selectedImc}?page=${page}&size=10&sort=serviceId,desc`, {
    //             headers: {
    //                 Authorization: bearerToken,
    //             },
    //         })
    //         .then((response) => {
    //             formatDate(response.data.content);
    //             setClosedService(response.data.content);
    //             setPageDetails(response.data);
    //             setLoading(false);
    //             if (response.data.first) {
    //                 setpreviousButton(true);
    //                 setnextButton(false);
    //             } else if (response.data.last) {
    //                 setpreviousButton(false);
    //                 setnextButton(true);
    //             } else {
    //                 setpreviousButton(false);
    //                 setnextButton(false);
    //             }
    //         })
    //         .catch(() => {
    //         });
    // };

    const getCandidatesAdmin = () => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/closeservice/${tennantname}?page=${page}&size=10&sort=${
                usertypeValue === 'EM' ? 'servicelist_id' : 'serviceId'
                },desc`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                formatDate(response.data.content);
                setClosedService(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch(() => { });
    };

    // const getCandidatesItecOthers = () => {
    //     setLoading(true);
    //     setpreviousButton(true);
    //     setnextButton(true);
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/closeservice/${selectedImc}?page=${page}&size=10&sort=servicelist_id,desc`, {
    //             headers: {
    //                 Authorization: bearerToken,
    //             },
    //         })
    //         .then((response) => {
    //             formatDate(response.data.content);
    //             setClosedService(response.data.content);
    //             setPageDetails(response.data);
    //             setLoading(false);
    //             if (response.data.first) {
    //                 setpreviousButton(true);
    //                 setnextButton(false);
    //             } else if (response.data.last) {
    //                 setpreviousButton(false);
    //                 setnextButton(true);
    //             } else {
    //                 setpreviousButton(false);
    //                 setnextButton(false);
    //             }
    //         })
    //         .catch(() => {
    //         });
    // };

    const getCandidatesBYUser = () => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/user-closeservice/${tennantname}?page=${page}&size=10&sort=dateModified,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                formatDate(response.data.content);
                setClosedService(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch(() => { });
    };

    useEffect(() => {
        if (userTeam != 'ITeC Team') {
            if (typereq === 'INDIVIDUAL' || typereq === 'CORPORATE') {
                if (searchQuery && searchQuery.length > 2) {
                    getSearchValueAdmin(searchQuery);
                } else {
                    getCandidatesBYUser();
                }
            } else {
                if (searchQuery && searchQuery.length > 2) {
                    getSearchValueAdmin(searchQuery);
                } else {
                    getCandidatesAdmin();
                }
            }
        }
    }, [bearerToken, page]);

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const getSearchValueAdmin = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/closeservice/${tennantname}?search=${data}&page=${page}&size=10&sort=${
                usertypeValue === 'EM' ? 'date_Modified' : 'dateModified'
                },desc`,
                axiosConfig)
            .then((res) => {
                // console.log('responseresponse11', res);
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setClosedService([]);
                    }
                    formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => { });
    };

    const clearField = () => {
        // console.log("clearField");
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        // getCandidatesAdmin();
        if (typereq === 'INDIVIDUAL' || typereq === 'CORPORATE') {
            getCandidatesBYUser();
        } else {
            getCandidatesAdmin();
            // setPage(0);
        }
        // getCandidatesBYUser();
        // console.log('clearclear')
    };

    const handleSearchQuery = (data) => {
        // setSearchQuery(searchData);
        setSearchQuery(data);
        // console.log('data', data);
        if (data && data.length > 2) {
            setNoRecordCount(false);
            getSearchValueAdmin(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            // getCandidatesAdmin();
            // if (userTeam != 'ITeC Team') {
            if (typereq === 'INDIVIDUAL' || typereq === 'CORPORATE') {
                getCandidatesBYUser();
            } else {
                getCandidatesAdmin();
                // setPage(0);
            }
            // }
        }
    };

    const handleClickRow = () => { };

    // const handleSearchQuery = (searchData) => {
    //     setSearchQuery(searchData);
    // };

    const classes = useStyles();
    const excludeColumns = ['comments'];

    const filteredRow = searchData && searchData.length ? searchData : rows;

    // const filteredRow = searchQuery
    //     ? rows.filter((searchRow) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headcells
    //             .map((col) => col)
    //             .some((key) => {
    //                 if (key.isConcat && searchRow[key.id]) {
    //                     const subdata = searchRow[key.id];
    //                     const mergedData = key.concatElem.map((concatdata) => {
    //                         return concatdata.split('.').reduce((acc, item) => {
    //                             if (Object.prototype.hasOwnProperty.call(acc, item)) {
    //                                 if (typeof acc[item] !== 'object') {
    //                                     return acc[item].toString().toLowerCase().includes(query);
    //                                 }
    //                                 return acc[item];
    //                             }
    //                             return false;
    //                         }, subdata);
    //                     });
    //                     return mergedData[0];
    //                 }
    //                 return excludeColumns.includes(key.id) ? false : searchRow[key.id].toString().toLowerCase().includes(query);
    //             });
    //     })
    //     : rows;

    return (
        <div className={classes.root}>
            {userTeam === 'ITeC Team' ? (
                <Noofcloseservices />
            ) : (
                    <ServiceLayout
                        title="Closed Services"
                        searchQuery={searchQuery}
                        onChange={handleSearchQuery}
                        clearField={clearField}
                        className={classes}
                    >
                        {rows && filteredRow.length > 0 ? (
                            <>
                                <ServiceTable
                                    headcells={typereq === 'INDIVIDUAL' || typereq === 'CORPORATE' ? headcellsClients : headcells}
                                    rows={filteredRow}
                                    handleClickRow={handleClickRow}
                                    post="admin"
                                    service="closed"
                                    handleCount={handleCount}
                                    pageDetails={pageDetails}
                                    loading={loading}
                                    prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                    Reports
                                />
                            </>
                        ) : (
                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            )}
                    </ServiceLayout>
                )}
        </div>
    );
};

export default ClosedService;
